export default function getSpanOptions(host) {
	return {
		attributes: {
			tagName: host.tagName?.toLowerCase(),
			componentId: host.nowId
		}
	};
}
